import {useContext} from 'react';
import NotificationsContext from '@mgp-fe/shared/ui/notifications/NotificationsContext.ts';

export default function useNotify() {
	return useContext(NotificationsContext);
}